// Modelos para o modal de vendas v2 (backend VendasController v2)
// NÃO editar financeiro.model.ts — use este arquivo para os tipos v2.

export interface EfetuarVendaDTO {
  idOrcamento: number;
  idCliente: number;
  formaPagamento: string;
  bandeiraCartao: string | null;
  numParcelas: number;
  idUsuario: number;
  previsaoEntrega: string;       // 'YYYY-MM-DD'
  valorEntrada: number | null;
  tipoVendaPagamento: string;
}

/** Resumo do pagamento escolhido, emitido pelo VendaModalV2 quando uma nova venda é efetuada. */
export interface ResumoVendaV2 {
  tipoVendaPagamento: string;
  formaPagamento: string;
  bandeiraCartao: string | null;
  numParcelas: number;
  valorEntrada: number | null;
  previsaoEntrega: string;
}

// ── Tipos de venda (tipoVendaPagamento) ─────────────────────────────────────
// FATURADA existe no enum mas não tem fluxo no backend — NÃO oferecida no modal.
export const TIPO_VENDA_A_VISTA    = 'A VISTA';
export const TIPO_VENDA_PARCELADA  = 'PARCELADA';
export const TIPO_VENDA_MISTA      = 'VENDA MISTA';

// ── Formas de pagamento (formaPagamento) ─────────────────────────────────────
export const FORMA_CREDITO_A_VISTA   = 'CREDITO A VISTA';
export const FORMA_CREDITO_PARCELADO = 'CREDITO PARCELADO';
export const FORMA_DEBITO            = 'DEBITO';
export const FORMA_ESPECIE           = 'ESPECIE';
export const FORMA_PIX               = 'PIX';
export const FORMA_BOLETO            = 'BOLETO';
export const FORMA_CHEQUE            = 'CHEQUE';

// ── Matriz Tipo × Formas aceitas ─────────────────────────────────────────────
// A VISTA: sem whitelist rígida no backend, mas o front oferece apenas as "à vista".
export const FORMAS_A_VISTA: string[] = [
  FORMA_CREDITO_A_VISTA,
  FORMA_DEBITO,
  FORMA_ESPECIE,
  FORMA_PIX,
];

// PARCELADA: whitelist rígida (qualquer outra → erro 304-01).
export const FORMAS_PARCELADA: string[] = [
  FORMA_BOLETO,
  FORMA_CHEQUE,
  FORMA_CREDITO_PARCELADO,
];

// VENDA MISTA (entrada): o backend não restringe; oferecer todas as formas usuais.
export const FORMAS_VENDA_MISTA: string[] = [
  FORMA_ESPECIE,
  FORMA_PIX,
  FORMA_DEBITO,
  FORMA_CREDITO_A_VISTA,
  FORMA_CREDITO_PARCELADO,
  FORMA_BOLETO,
  FORMA_CHEQUE,
];

// ── Formas que exigem bandeira de cartão ─────────────────────────────────────
export const FORMAS_COM_BANDEIRA: string[] = [
  FORMA_CREDITO_A_VISTA,
  FORMA_CREDITO_PARCELADO,
  FORMA_DEBITO,
];

// ── Formas parceladas (exigem numParcelas > 1) ────────────────────────────────
export const FORMAS_PARCELADAS: string[] = [
  FORMA_CREDITO_PARCELADO,
  FORMA_BOLETO,
  FORMA_CHEQUE,
];

// ── Bandeiras de cartão ──────────────────────────────────────────────────────
export type BandeiraCartaoV2 = 'MASTERCARD' | 'VISA' | 'ELO' | 'AMEX' | 'OUTROS';

export const BANDEIRAS: { value: BandeiraCartaoV2; label: string }[] = [
  { value: 'MASTERCARD', label: 'Mastercard' },
  { value: 'VISA',       label: 'Visa' },
  { value: 'ELO',        label: 'Elo' },
  { value: 'AMEX',       label: 'Amex' },
  { value: 'OUTROS',     label: 'Outros' },
];

// ── Códigos de erro do backend ────────────────────────────────────────────────
export const ERRO_ACAO_NAO_PERMITIDA   = '400-01';
export const ERRO_CPF_CNPJ_INVALIDO    = '500-03';
export const ERRO_CLIENTE_RESTRICAO    = '500-05';
export const ERRO_FUNCAO_NAO_IMPL      = '304-01';
export const ERRO_ADICIONAR_PAGAMENTO  = '500-06';
// D-05: ERRO_EFETIVAR_VENDA e ERRO_BAIXAR_PARCELA foram renumerados no backend
// para não colidir mais com CLIENTE_RESTRICAO_ATIVA (500-05) e
// ERRO_ADICIONAR_PAGAMENTO (500-06), que permanecem como estavam.
export const ERRO_EFETIVAR_VENDA       = '500-07';
export const ERRO_BAIXAR_PARCELA       = '500-08';
